import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { initSeo } from './seo';

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/theme.css';

const app = createApp(App);

app.use(i18n).use(router).mount('#app');

initSeo(router, i18n);
